/**
 * Creates header dropdown menu items for equipment details
 * @param {boolean} isActive - Equipment active status
 * @param {Function} t - Translation function
 * @param {Function} hasPermission - Permission check function
 * @param {Object} MODULES - Module constants
 * @param {Object} ACTIONS - Action constants
 * @returns {Array} Menu items configuration
 */
export const createMoreMenuItems = (isActive, t, hasPermission, MODULES, ACTIONS) =>
  [
    hasPermission?.(MODULES.EQUIPMENT, ACTIONS.CREATE) && {
      key: "duplicate",
      label: t("global.duplicate")
    },
    hasPermission?.(MODULES.EQUIPMENT, ACTIONS.EDIT) && {
      key: "deactivate",
      label: isActive ? t("global.deactivate") : t("global.activate")
    },
    hasPermission?.(MODULES.EQUIPMENT, ACTIONS.EDIT) && {
      key: "delete",
      label: t("global.delete"),
      danger: true
    }
  ].filter(Boolean)

export const createTabItems = (t) => [
  {
    key: "details",
    label: t("equipment.details.details_title")
  },
  {
    key: "calendar",
    label: "Calendar"
  }
]
